import React, { useCallback } from 'react';
import { useBackButtonState } from 'src/shef-global-state/backButtonState';
import { TrackedNavLink } from '../TrackedNavLink';

export const BackButton: React.FC<Pick<React.HTMLAttributes<HTMLAnchorElement>, 'children' | 'className'>> = ({
  className,
  children,
}) => {
  const { backPath, goBack } = useBackButtonState();

  const onClick = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      goBack();
      event.preventDefault();
    },
    [goBack]
  );

  return (
    <TrackedNavLink className={className} to={backPath} onClick={onClick} name='back-button'>
      {children}
    </TrackedNavLink>
  );
};
